import axios from 'axios';
import * as actionTypes from './actionTypes';
import { getUserData } from '../../views/pages/user/userData/UserDataPull.js';
import { getDbHeaders, retrieveAppSubscriptions } from "../../dataManagement/AnimoApi.js";

export const authStart = () => {
  return {
    type: actionTypes.AUTH_START,
  };
};

export const authSuccess = (
  token,
  userName,
  userId,
  userLevel,
  userPartner,
  userPartnerType,
  userPartnerName,
  userPartnerLogo,
  userBU,
  userSSO,
  userISO,
  sidebarLogo,
  activeJob,
  activePhase,
  userMultiCountry,
  userCountry,
  userViewStyle,
  userViewPartner,
  userDistrict,
  userWhiteMode,
  userDisplayName,
  userEmail,
  passwordResetRequired,
  initial_page_target
) => {
  return {
    type: actionTypes.AUTH_SUCCESS,
    token: token,
    userName: userName,
    userLevel: userLevel,
    userId: userId,
    userPartner: userPartner,
    userPartnerType: userPartnerType,
    userPartnerName: userPartnerName,
    userPartnerLogo: userPartnerLogo,
    userBU: userBU,
    userSSO: userSSO,
    passwordResetRequired: passwordResetRequired,
    userISO: userISO,
    sidebarLogo: sidebarLogo,
    activeJob: activeJob,
    activePhase: activePhase,
    userMultiCountry: userMultiCountry,
    userCountry: userCountry,
    userViewStyle: userViewStyle,
    userViewPartner: userViewPartner,
    userDistrict: userDistrict,
    userWhiteMode: userWhiteMode,
    userDisplayName: userDisplayName,
    userEmail: userEmail,
  };
};

export const authFail = (error) => {
  return {
    type: actionTypes.AUTH_FAIL,
    error: error,
  };
};

export const checkAuthTimeout = (expirationTime) => {
  return (dispatch) => {
    setTimeout(() => {
      dispatch(logout());
    }, expirationTime * 2000);
  };
};

export const logout = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("expirationDate");
  return {
    type: actionTypes.AUTH_LOGOUT,
  };
};

export const authLogin = (username, password) => {
  console.log("this is the url", process.env.REACT_APP_LOGIN_URL);
  return (dispatch) => {
    dispatch(authStart());
    axios
      .post(
        process.env.REACT_APP_LOGIN_URL,
        {
          username: username,
          password: password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(async (res) => {
        const userName = JSON.parse(res.config.data).username;
        const token = res.data.key;
        const expirationDate = new Date(new Date().getTime() + 3600 * 12000); // 12 hours
        const dbUrl = process.env.REACT_APP_API_URL; // in the future this will come from CoreLink and be stored in redux
        const dbHeaders = getDbHeaders(token);
        localStorage.setItem("userName", userName);
        localStorage.setItem("token", token);
        localStorage.setItem("expirationDate", expirationDate);
        await getUserData(dbUrl, dbHeaders, userName, dispatch);
        // dispatch(authSuccess(token));
        dispatch(authCheckState());
        dispatch(checkAuthTimeout(3600));
      })
      .catch((err) => {
        console.log(err);
        if (err.message === "Failed to fetch") {
          // Handle connection refused error
          console.error("Connection refused: Cannot reach the server.");
        }
        dispatch(authFail(err));
      });
  };
};

export const authSignup = (username, email, password1, password2) => {
  return (dispatch) => {
    dispatch(authStart());
    axios
      .post(`http://127.0.0.1:8000/rest-auth/registration/`, {
        username: username,
        email: email,
        password1: password1,
        password2: password2,
      })
      .then((res) => {
        const token = res.data.key;
        const expirationDate = new Date(new Date().getTime() + 3600 * 12000); // 12 hours
        localStorage.setItem("token", token);
        localStorage.setItem("expirationDate", expirationDate);
        // dispatch(authSuccess(token));
        dispatch(authCheckState());
        dispatch(checkAuthTimeout(3600));
      })
      .catch((err) => {
        dispatch(authFail(err));
      });
  };
};

export const authCheckState = () => {
  // console.log("in authCheckState");
  return (dispatch) => {
    const userName = localStorage.getItem("userName");
    const token = localStorage.getItem("token");
    if (token === undefined) {
      dispatch(logout());
    } else {
      const expirationDate = new Date(localStorage.getItem("expirationDate"));
      if (expirationDate <= new Date()) {
        dispatch(logout());
      } else {
        const header = {
          headers: {
            Authorization: `Token ${token}`,
          },
        };
        // let initialPage = null
        axios.get(process.env.REACT_APP_API_URL + `users/?username=${userName}&fields=id`, header).then((res) => {
          let sidebarLogo = false;
          if (res.data && res.data.length && res.data[0].id) {
            axios
              .get(
                process.env.REACT_APP_API_URL +
                  `personnel/?user=${res.data[0].id}&fields=id,partner,email,level,business_unit,initial_page_target,sso,iso,multi_country,country,view_style,view_partner,active_job,active_phase,district,light_mode,first_name,last_name,require_password_reset`,
                header
              )
              .then((res) => {
                if (res.data && res.data.length) {
                  if (res.data[0].initial_page_target) {
                    dispatch(setInitialPage(res.data[0].initial_page_target));
                  }
                  getPersonRouteApps(process.env.REACT_APP_API_URL, header, res.data[0].id, res.data[0].partner)
                    .then((personAppList) => {
                      dispatch(setPersonRouteApps(personAppList));
                    })
                    .catch((error) => {
                      console.error(error);
                    });

                  const user = res.data[0];
                  const userId = res.data[0].id;
                  const userPartner = res.data[0].partner;
                  const userLevel = res.data[0].level;
                  const userBU = res.data[0].business_unit;
                  const userSSO = res.data[0].sso;
                  const passwordResetRequired = res.data[0].require_password_reset;
                  const userISO = res.data[0].iso;
                  const userMultiCountry = res.data[0].multi_country;
                  const userCountry = res.data[0].country;
                  const userViewStyle = res.data[0].view_style;
                  const userViewPartner = res.data[0].view_partner;
                  const activeJob = res.data[0].active_job;
                  const activePhase = res.data[0].active_phase;
                  const userDistrict = res.data[0].district;
                  const userWhiteMode = res.data[0].light_mode;
                  const userDisplayName = res.data[0].first_name + " " + res.data[0].last_name;
                  const userEmail = res.data[0].email;
                  const initialPage = res.data[0].initial_page_target;
                  axios.get(process.env.REACT_APP_API_URL + `partners/17/?fields=media_file_link`, header).then((res) => {
                    sidebarLogo = res.data.media_file_link;
                  });

                  if (res.data[0].partner) {
                    axios.get(process.env.REACT_APP_API_URL + `partners/${res.data[0].partner}/?fields=type,name,media_file_link,initial_page_target`, header).then((res) => {
                      const userPartnerType = res.data.type;
                      const userPartnerName = res.data.name;
                      const userPartnerLogo = res.data.media_file_link;
                      if (sidebarLogo) {
                        dispatch(
                          authSuccess(
                            token,
                            userName,
                            userId,
                            userLevel,
                            userPartner,
                            userPartnerType,
                            userPartnerName,
                            userPartnerLogo,
                            userBU,
                            userSSO,
                            userISO,
                            sidebarLogo,
                            activeJob,
                            activePhase,
                            userMultiCountry,
                            userCountry,
                            userViewStyle,
                            userViewPartner,
                            userDistrict,
                            userWhiteMode,
                            userDisplayName,
                            userEmail,
                            passwordResetRequired
                          )
                        );
                      } else
                        dispatch(
                          authSuccess(
                            token,
                            userName,
                            userId,
                            userLevel,
                            userPartner,
                            userPartnerType,
                            userPartnerName,
                            userPartnerLogo,
                            userBU,
                            userSSO,
                            userISO,
                            "",
                            activeJob,
                            activePhase,
                            userMultiCountry,
                            userCountry,
                            userViewStyle,
                            userViewPartner,
                            userDistrict,
                            userWhiteMode,
                            userDisplayName,
                            userEmail,
                            passwordResetRequired
                          )
                        );
                    });
                  } else
                    dispatch(
                      authSuccess(
                        token,
                        userName,
                        userId,
                        userLevel,
                        "",
                        "",
                        "",
                        "",
                        "",
                        userSSO,
                        userISO,
                        "",
                        activeJob,
                        activePhase,
                        userMultiCountry,
                        userCountry,
                        userViewStyle,
                        userViewPartner,
                        "",
                        userWhiteMode,
                        userDisplayName,
                        userEmail,
                        passwordResetRequired,
                        initialPage
                      )
                    );
                }
              });
          } else dispatch(authSuccess(token, userName));
        });

        dispatch(checkAuthTimeout((expirationDate.getTime() - new Date().getTime()) / 1000));
      }
    }
  };
};
const getPersonRouteApps = async (dbUrl, dbHeaders, userId, userPartner) => {
  try {
    let personAppList = await retrieveAppSubscriptions(dbUrl, dbHeaders, userId, userPartner, false, "routes");
    if (personAppList && personAppList.length) {
      personAppList = personAppList.map((app) => app.app_name);
      return personAppList;
    } else {
      return [];
    }
  } catch (error) {
    console.error("An error occurred while retrieving app subscriptions:", error);
  }
};
export const setPersonRouteApps = (personRouteApps) => {
  return {
    type: actionTypes.SET_PERSON_ROUTE_APPS,
    personRouteApps: personRouteApps,
  };
};
export const setFocusWell = (focusWell) => {
  return {
    type: actionTypes.SET_FOCUS_WELL,
    focusWell: focusWell,
  };
};

export const setUser = (user) => {
  return {
    type: actionTypes.SET_USER,
    user: user,
  };
};
export const setUserId = (userId) => {
  return {
    type: actionTypes.SET_USER_ID,
    userId: userId,
  };
};

export const setUserLevel = (userLevel) => {
  return {
    type: actionTypes.SET_USER_LEVEL,
    userLevel: userLevel,
  };
};

export const updateInsightRightModal = (insightSegment) => {
  console.log("We have an auth insight", insightSegment);
  return {
    type: actionTypes.RIGHT_INSIGHT_MODAL,
    insightSegment: insightSegment,
  };
};

export const setInitialPage = (initialPage) => {
  return {
    type: actionTypes.SET_INITIAL_PAGE,
    initialPage: initialPage,
  };
};
export const setUserPartner = (userPartner) => {
  return {
    type: actionTypes.SET_USER_PARTNER,
    userPartner: userPartner,
  };
};

export const setUserPartnerType = (userPartnerType) => {
  return {
    type: actionTypes.SET_USER_PARTNER_TYPE,
    userPartnerType: userPartnerType,
  };
};

export const setUserBU = (userBU) => {
  return {
    type: actionTypes.SET_USER_BU,
    userBU: userBU,
  };
};

export const setUserMultiCountry = (userMultiCountry) => {
  return {
    type: actionTypes.SET_USER_MULTI_COUNTRY,
    userMultiCountry: userMultiCountry,
  };
};
export const setUserCountry = (userCountry) => {
  return {
    type: actionTypes.SET_USER_COUNTRY,
    userCountry: userCountry,
  };
};

export const setUserViewStyle = (userViewStyle) => {
    return {
        type: actionTypes.SET_USER_VIEW_STYLE,
        userViewStyle: userViewStyle
    }
};

export const setUserViewPartner = (userViewPartner) => {
    return {
        type: actionTypes.SET_USER_VIEW_PARTNER,
        userViewPartner: userViewPartner
    }
};
export const setActiveJob = (activeJob) => {
    return {
        type: actionTypes.SET_ACTIVE_JOB,
        activeJob: activeJob
    }
};

export const setActivePhase = (activePhase) => {
    return {
        type: actionTypes.SET_ACTIVE_PHASE,
        activePhase: activePhase
    }
};
export const setFocusPhaseDetails = (focusPhaseDetails) => {
  return {
    type: actionTypes.SET_FOCUS_PHASE_DETAILS,
    focusPhaseDetails: focusPhaseDetails,
  };
};

export const setUrlMatch = (match) => {
    return {
        type: actionTypes.SET_URL_MATCH,
        match: match
    }
};

export const updateActivityDate = (activityDate) => {
    return {
        type: actionTypes.ACTIVITY_DATE,
        activityDate: activityDate
    }
};

export const addActivity = (addedActivity) => {
    return {
        type: actionTypes.ADD_ACTIVITY,
        addedActivity: addedActivity
    }
};

export const editActivity = (editedActivity) => {
    return {
        type: actionTypes.EDIT_ACTIVITY,
        editedActivity: editedActivity
    }
};

export const addSurvey = (addedSurvey) => {
    return {
        type: actionTypes.ADD_SURVEY,
        addedSurvey: addedSurvey
    }
};

export const addProjection = (addedProjection) => {
    return {
        type: actionTypes.ADD_PROJECTION,
        addedProjection: addedProjection
    }
};

export const addBhaMotor = (addedBhaMotor) => {
    return {
        type: actionTypes.ADD_BHA_MOTOR,
        addedBhaMotor: addedBhaMotor
    }
};

export const addBhaAssets = (addedBhaAssets) => {
    return {
        type: actionTypes.ADD_BHA_ASSETS,
        addedBhaAssets: addedBhaAssets
    }
};


export const addDrillPipeAssets = (addedDrillPipeAssets) => {
    return {
        type: actionTypes.ADD_DRILLPIPE_ASSETS,
        addedDrillPipeAssets: addedDrillPipeAssets
    }
};

export const addReceivedShipment = (addedReceivedShipment) => {
    return {
        type: actionTypes.ADD_RECIEVED_SHIPMENT,
        addedReceivedShipment: addedReceivedShipment
    }
};

export const openInsightForm = (formData) => ({
  type: actionTypes.OPEN_INSIGHT_FORM,
  payload: formData,
});

export const closeInsightForm = () => ({
  type: actionTypes.CLOSE_INSIGHT_FORM,
});

